import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-apollo';
import uniq from 'lodash.uniq';
import { communitiesQuery } from '../constants/queries';
import randomize from '../utils/randomize';

export const CommunitiesContext = React.createContext();

export default function CommunitiesProvider({ children, city }) {
  const [communities, setCommunities] = useState(null);
  const [page, setPage] = useState(1);
  const [showMore, setShowMore] = useState(true);

  const { data, fetchMore, loading } = useQuery(communitiesQuery, {
    variables: { city_name: city, page: '1', size: '20' },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    // If communities is null, set initial Communities
    if (!communities && data && data.communities) {
      setCommunities(randomize(data.communities.collection));
    } else if (communities) {
      setCommunities(
        uniq([...communities, ...randomize(data.communities.collection)])
      );
      setPage(data.communities.meta.current_page);
    }
    // eslint-disable-next-line
  }, [data]);

  const getMoreCommunities = () => {
    fetchMore({
      variables: {
        page: (page + 1).toString(),
        per: 50,
      },
      updateQuery(_, { fetchMoreResult }) {
        const { current_page, total_pages } = fetchMoreResult.communities.meta;
        if (current_page >= total_pages) setShowMore(false);
        return fetchMoreResult;
      },
    });
  };

  return (
    <CommunitiesContext.Provider
      value={{
        city,
        data,
        fetchMore,
        communities,
        setCommunities,
        page,
        setPage,
        getMoreCommunities,
        showMore,
        loading,
      }}
    >
      {children}
    </CommunitiesContext.Provider>
  );
}
